// @flow
import React from 'react';
import { navigate } from '@reach/router';
import { MainAppContainer } from 'screens/shared/style';
import { Tabs } from 'freemium-ui';
import { StyledHeader } from './style';
import i18n from '../../i18n';

type IncidentsProps = {
  path: string,
  '*': string,
  children: React.ElementType
};

const options = [
  {
    id: 'INC',
    name: i18n.t('screens.incidents.labelIncidents'),
    type: 'public',
    href: '/admin/incidents/public'
  },
  {
    id: 'SM',
    name: i18n.t('screens.incidents.labelMaintenance'),
    type: 'planned',
    href: '/admin/incidents/planned'
  }
  // {
  //   id: 'GA',
  //   name: 'Announcement',
  //   type: 'announcement',
  //   href: '/admin/incidents/announcement'
  // },
  // {
  //   id: 'QSA',
  //   name: 'Quick status change',
  //   type: 'status',
  //   href: '/admin/incidents/status'
  // }
];

const Incidents = (props: IncidentsProps) => {
  const { path, children } = props;

  React.useEffect(() => {
    if (path === '/') navigate(`/admin/incidents/public`);
  }, [path]);

  const value = options.find(opt => opt.type === props['*']);

  return (
    <MainAppContainer direction="column">
      <StyledHeader>
        <Tabs
          value={(value && value.id) || ''}
          onChange={(e, v) => navigate(v.href)}
          options={options}
        />
      </StyledHeader>
      {children}
    </MainAppContainer>
  );
};

export default Incidents;
